<button type="button"
        [matMenuTriggerFor]="modelMenu"
        matButton
        class="model-selector-button"
        #tooltip="matTooltip"
        [matTooltip]="getModelTooltip()"
        matTooltipPosition="above"
        aria-label="Select model"
        [disabled]="multiSessionService.hasReachedMaxConcurrency() || isCurrentSessionSubmitting()">
  {{ selectedModel.model }}
  <mat-icon iconPositionEnd fontIcon="expand_more"/>
</button>

<mat-menu #modelMenu="matMenu" class="model-menu">
  <div class="model-search-container" (click)="$event.stopPropagation()">
    <mat-form-field appearance="outline" class="model-search">
      <mat-label>Search Models</mat-label>
      <input matInput (keyup)="filterModels($event)" placeholder="Search Models" autocomplete="off">
      <mat-icon matSuffix fontIcon="search"></mat-icon>
    </mat-form-field>
  </div>
  <div class="model-list">
    @if (groupedModels().length === 0) {
      <div class="empty-models">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Loading available models...</span>
      </div>
    } @else {
      @for (accountGroup of groupedModels(); track accountGroup.accountName) {
        <div class="account-group">
          <div class="account-name">{{ accountGroup.accountName }}</div>
          @for (model of accountGroup.models; track model) {
            <button mat-menu-item (click)="selectModel(accountGroup.accountName, model)">
              @defer {
                @if (isSelectedModel(accountGroup.accountName, model)) {
                  <ng-container>
                    {{ model }}
                    <mat-icon class="model-selected-icon" fontIcon="check"></mat-icon>
                  </ng-container>
                } @else {
                  {{ model }}
                }
              }
            </button>
          }
        </div>
        @if (!$last) {
        }
        <mat-divider></mat-divider>
      }
    }
  </div>
</mat-menu>
